import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { type AppState } from '../app.store';

const googleApiOauthSelector = (state: AppState) => state.userData.googleApiOauth;
const googleAccIdSelector = (state: AppState) => googleApiOauthSelector(state)?.googleAccId;

export const useCurrentGoogleAccountIdSelector = () => useSelector(googleAccIdSelector);
